module.exports = __webpack_public_path__ + "img/info.ef7452fe.svg";